import axios from 'axios'
import './common'

export default {
    getList: (params) => axios.get(`/schools`, { params: params }),
    get: (id) => axios.get(`/schools/${id}`),
    create: (data) => axios.post(`/schools`, data),
    update: (id, data) => axios.put(`/schools/${id}`, data),
    delete: (id) => axios.delete(`/schools/${id}`),
    enable: (id) => axios.patch(`/schools/${id}/enable`),
    disable: (id) => axios.patch(`/schools/${id}/disable`),

}